import * as ko from "knockout";
import { warranty_request } from "./warranty_request";
import labels from "app/labels";

export class spare_warranty_request extends warranty_request {
  part_id: KnockoutObservable<any>;
  invoice_dttm1: KnockoutObservable<Date>;
  failure_dttm2: KnockoutObservable<Date>;
  counterTotalReplaced: KnockoutObservable<number>;
  counterTotalFailed: KnockoutObservable<number>;
  spareInvoiceNumber: KnockoutObservable<string>;
  good_will_transaction_reason: KnockoutObservable<string>;
  part_serial_id: KnockoutObservable<string>;

  constructor(item: any) {
    super(item);

    this.part_id = ko.observable();
    this.user_def3 = ko.observable(item.user_def3);
    this.counterTotalReplaced = ko.observable();
    this.counterTotalFailed = ko.observable();
    this.spareInvoiceNumber = ko.observable();
    this.good_will_transaction_reason = ko.observable();
    this.part_serial_id = ko.observable();

    this.invoice_dttm1 = ko.observable(this.formatJSONDate(item.invoice_dttm1));
    this.invoice_dttm1.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_INVOICE_DATE_REQUIRED"),
      },
    });
    this.failure_dttm2 = ko.observable(this.formatJSONDate(item.failure_dttm2));
    this.failure_dttm2.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_FAILURE_DATE_REQUIRED"),
      },
    });
    this.part_id.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_PART_REQUIRED"),
      },
    });
    this.counterTotalReplaced.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_TOT_COUNTER_REP_REQUIRED"),
      },
    });
    this.counterTotalFailed.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_TOT_COUNTER_FAIL_REQUIRED"),
      },
    });
    this.user_def6.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_PHENOMENON_REQUIRED"),
      },
    });
    this.spareInvoiceNumber.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_INVOICE_NR_REQUIRED"),
      },
    });
  }
}
